import React, { useState, useEffect } from 'react';
import { Dropdown, Menu, Button } from 'antd';
import PropTypes from 'prop-types';
import { UploadAudioModal } from './UploadAudioModal';

export const EditAudioButton = (props) => {
  const { text, generateTextAudio, onChange } = props;
  const [uploadedAudio, setUploadedAudio] = useState(null);
  const [isUploadModalOpened, setIsUploadModalOpened] = useState(false);

  const openUploadAudioModal = () => {
    setIsUploadModalOpened(true);
  };

  const closeUploadAudioModal = () => {
    setIsUploadModalOpened(false);
  };

  const handleUploadedAudio = (uploadedAudio) => {
    setUploadedAudio({ ...uploadedAudio, text });
  };

  const handleGenerateAudio = async () => {
    const { fileUrl: audioFileUrl, fileKey: audioFileKey } = await generateTextAudio(text);
    onChange(text, { audioFileUrl, audioFileKey });
    setUploadedAudio(null);
  };

  useEffect(() => {
    if (!uploadedAudio) {
      return;
    }

    const { text, audioFileKey, audioBlob } = uploadedAudio;
    const audioFileUrl = URL.createObjectURL(audioBlob);

    onChange(text, { audioFileKey, audioFileUrl });

    return () => {
      URL.revokeObjectURL(audioBlob);
    };
  }, [uploadedAudio]);

  const menu = (
    <Menu>
      <Menu.Item key="upload-audio" onClick={openUploadAudioModal}>
        Upload Audio
      </Menu.Item>
      <Menu.Item key="generate-audio" onClick={handleGenerateAudio}>
        Generate Audio
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menu} trigger={['click']}>
        <Button>Edit Audio</Button>
      </Dropdown>

      {isUploadModalOpened && (
        <UploadAudioModal onChange={handleUploadedAudio} onClose={closeUploadAudioModal} />
      )}
    </>
  );
};

EditAudioButton.propTypes = {
  text: PropTypes.string,
  generateTextAudio: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};
